import { getUrl } from './url';

import type { Locale } from '@sharesight/gatsby-plugin-sharesight-localization';

interface getCanonicalHrefProps {
  currentPath: string;
  siteUrl: string;
  currentLocale: Locale;
}

export const getCanonicalHref = ({
  currentPath,
  currentLocale,
  siteUrl,
}: getCanonicalHrefProps) => {
  // For partner pages, we want to use the /partners/ path as the canonical URL to prevent duplicate content errors
  if (currentPath.includes('/partners/pages/')) {
    return getUrl({ path: `/${currentLocale.path}/partners/`, siteUrl });
  }
  return getUrl({ path: currentPath, siteUrl });
};
